<div class="app-dialog-footer modal-footer">
    <ng-content></ng-content>
</div>